import React, { useEffect, useRef, useState } from 'react';
import {
  PreviewLinkContainer,
  PreviewLinkController,
  PreviewLinkUrl,
  PreviewLinkButton,
} from '../../atoms';
import { TextPopupWrapper } from '../../../../molecules';
import { LinkForm } from '../index';
import Editor from '../../../../Editor';

// Old @flow
// import type { Node as ReactNode } from 'react';
// import type { Inline } from 'slate';
// import type { Editor as SlateEditor } from 'slate-react';
// import type { LinkFormState } from '../index';

// типа LinkWrapperProps использовался в componentDisUpdate
// кототрый не поддерживается в функциональных компонентах
// export type LinkWrapperProps = {
//   editor: SlateEditor,
//   node: Inline,
//   attributes: {},
//   children: ReactNode[]
// }
// 
// типа LinkWrapperState использовался в componentWillUpdate
// кототрый не поддерживается в функциональных компонентах
// export type LinkWrapperState = {
//   isShowPopup: boolean,
//   isShowPreview: boolean,
//   isLinkChanged: boolean
// }

const LinkWrapper = ({ editor, node, attributes, children }) => {
  const [isShowPopup, setShowPopup] = useState(false);
  const [isEditMode, setEditMode] = useState(false);
  const inputRef = useRef(null);

  // Аналог componentDidMount
  useEffect(() => {
    // Если у узла есть атрибут isCreated, то это значит,
    // что узел был только что создан и нужно
    // СРАЗУ показать форму для ввода ссылки
    if (node.data.get('isCreated')) {
      setShowPopup(true);
      setEditMode(true);
      editor.deselect();
    }
  }, []);

  // Ставим фокус при появлении LinkForm
  useEffect(() => {
    if (isShowPopup && isEditMode && inputRef.current) {
      inputRef.current.focus();
      // Для совместимости с paste: ставим курсор в конец
      const len = inputRef.current.value.length;
      inputRef.current.setSelectionRange(len, len);
    }
  }, [isShowPopup, isEditMode, inputRef]);

  const changeLink = ({ text, href }) => {
    const firstText = node.getFirstText();
    setShowPopup(false);

    if (!href || href.trim().length === 0) {
      deleteLink();
      return;
    }

    if (!text || text.trim().length === 0) {
      editor.removeNodeByKey(node.key);
      return;
    }

    editor.setTextByKey(firstText.key, text);
    editor.setNodeByKey(node.key, Editor.node.Link({ href }));
  };

  const deleteLink = () => {
    editor.unwrapInlineByKey(node.key, 'a');
  }

  // e: SyntheticEvent<HTMLElement>
  const onDeleteLink = (e) => {
    e.preventDefault();
    e.stopPropagation();
    deleteLink();
    setShowPopup(false);
  };

  const handleShowPopup = (isShowed) => setShowPopup(isShowed);

  const openLinkPopup = () => {
    setShowPopup(true);
    setEditMode(false);
    editor.deselect();
  };

  // e: SyntheticEvent<HTMLElement>
  const enterEditMode = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setEditMode(true);
  };

  const href = node.data.get('href');

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer nofollow"
      onClick={openLinkPopup}
      {...attributes}
    >
      <TextPopupWrapper
        editor={editor}
        node={node}
        isShowPopup={isShowPopup}
        handleShowPopup={handleShowPopup}
      >
        {isEditMode ? (
          <LinkForm
            href={href}
            text={node.text}
            onSubmit={changeLink}
            childrens={children}
            inputRef={inputRef} // Прокидываем ref, чтобы фокусить инпут
          />
        ) : (
          <PreviewLinkContainer>
            <PreviewLinkUrl target="_blank" href={href}>
              {href}
            </PreviewLinkUrl>
            <PreviewLinkController>
              <PreviewLinkButton onClick={enterEditMode}>
                Изменить  
              </PreviewLinkButton>
              <PreviewLinkButton
                onClick={onDeleteLink}
                color="#fd6073"
              >
                Удалить
              </PreviewLinkButton>
            </PreviewLinkController>
          </PreviewLinkContainer>
        )}
      </TextPopupWrapper>
      {children}
    </a>
  );
}

export default LinkWrapper;
